var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJasmineidleeyeballs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.9 421.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e9e8e8;\n        stroke: #e9e8e8;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #b1b1b1;\n        stroke: #b1b1b1;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #535453;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.96,
    y: 79.99,
    width: 119.06,
    height: 44.95
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.59,98.66s-1.16,2.89,0,5.14,3.6,4.2,5.63,4.2,5.5-3.12,5.5-3.12v-3.1s-.52-4.27-2.98-5.01c-2.59-.78-7.15,1.97-8.16,1.89h.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.08,98.66s1.16,2.89,0,5.14-3.6,4.2-5.63,4.2-5.5-3.12-5.5-3.12v-3.1s1.79-3.72,4.16-4.44c2.64-.8,5.94,1.4,6.97,1.33h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.06,101.5s.45,3.51-.7,5.08-4.04,2.56-6.85,2.31-4.79-2.97-5.78-4.7-.66-4.04,0-5.53,2.64-4.04,7.53-3.47,5.76,3.76,5.8,6.31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.97,98.66s.99,3.8,0,5.53-2.97,4.46-5.78,4.7-5.69-.74-6.85-2.31-.7-5.08-.7-5.08c0,0,.21-5.3,5.71-5.79s7.62,2.95,7.62,2.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJasmineidleeyeballs);
export default __webpack_public_path__ + "static/media/jasmine idle eyeballs.4d093562855d5f1cde43b299acb3c1b8.svg";
export { ForwardRef as ReactComponent };